import React, {useEffect, useContext, useState} from 'react';
import L from 'leaflet'
import "leaflet.vectorgrid"
import { useMap } from 'react-leaflet';
import { Context } from '../store/reducer';
import Popup98 from "./Spot/menu/popup98";

/**
 * 不動産情報APIのvectorタイル
 * 
 * @param id
 * @param url
 * @param layerName
 * @param color
 * @param opacity
 * @param borderColor
 * @param option
 */ 
const VectorGrid98 = ({id, url, layerName, color, opacity, borderColor, option}) => {
    const map = useMap()
    const { state } = useContext(Context);

    const [showPopup, setShowPopup ]= useState(false);
    const [polygonProperties, setPolygonProperties ]= useState([]);
    const [lat, setLat] = useState();
    const [lng, setLng] = useState();

    /**
     * シェイプが表示対象のものかどうかを判定する。
     * @param id
     * @param properties
     * @returns {boolean}
     */
    const checkTarget = (id, properties) => {
        let isTarget = false;

        if (option.fetchedServerKey === "XKT001") {

            // 都市計画/区域区分の場合
            if (id === "vis_98_36" && properties["kubun_id"].toString() === "21"
              || id === "vis_98_37" && properties["kubun_id"].toString() === "22"
              || id === "vis_98_38" && properties["kubun_id"].toString() === "23") {
                isTarget = true;
            }
        } else if (option.fetchedServerKey === "XKT002") {

            // 用途地域 
            if (id === "vis_98_39" && properties["youto_id"].toString() === "1"
              || id === "vis_98_40" && properties["youto_id"].toString() === "2"
              || id === "vis_98_41" && properties["youto_id"].toString() === "3"
              || id === "vis_98_42" && properties["youto_id"].toString() === "4"
              || id === "vis_98_43" && properties["youto_id"].toString() === "5"
              || id === "vis_98_44" && properties["youto_id"].toString() === "6"
              || id === "vis_98_45" && properties["youto_id"].toString() === "7"
              || id === "vis_98_46" && properties["youto_id"].toString() === "8"
              || id === "vis_98_47" && properties["youto_id"].toString() === "9"
              || id === "vis_98_48" && properties["youto_id"].toString() === "10"
              || id === "vis_98_49" && properties["youto_id"].toString() === "11"
              || id === "vis_98_50" && properties["youto_id"].toString() === "12"
              || id === "vis_98_51" && properties["youto_id"].toString() === "13") {
                isTarget = true;
            }
        } else if (option.fetchedServerKey === "XKT003") {

            // 立地適正化
            if (id === "vis_98_56" && properties["kubun_id"].toString() === "31"
              || id === "vis_98_57" && properties["kubun_id"].toString() === "32") {
                isTarget = true;
            }
        } else if (option.fetchedServerKey === "XKT014") {

            // 防火地域
            if (id === "vis_98_52" && properties["kubun_id"].toString() === "24"
              || id === "vis_98_53" && properties["kubun_id"].toString() === "25") {
                isTarget = true;
            }
        } else if (option.fetchedServerKey === "XKT024") {

            if (properties["kubun_id"].toString() === "19") {
                isTarget = true;
            }

        } else if (option.fetchedServerKey === "XKT023") {

            if (properties["kubun_id"].toString() === "1") {
                isTarget = true;
            }
        } else if (option.fetchedServerKey === "XKT004") {

            isTarget = true;

        } else if (option.fetchedServerKey === "XKT005") {

            isTarget = true;

        }
        
        return isTarget;
    }
    
    const getStyles = (id, properties, color, option) => {

        let fillColor;
        let borderColor = "transparent";  
        
        // isTargetを使って制御すことで、都市計画と区域区分のように同じ位置に複数のfeatureが重なっているパターンにも対応している。
        const isTarget = checkTarget(id, properties);

        if (isTarget) {
            borderColor = color;
            fillColor = option.backgroundColor === undefined ? color : option.backgroundColor;
        } else {
            borderColor = "transparent";
            fillColor = "transparent";
        }

        return {
            value: id, // debug用にセットしている。clickイベントで使用する。
            opacity: isTarget ? state.opacity : 0,
            fill: isTarget ? true : false,
            color: borderColor,
            fillColor: fillColor,
            dashArray: 0,
            fillOpacity: isTarget ? state.opacity : 0
        }
    } 
    
    useEffect(() => {
        const vectorGrid = L.vectorGrid.protobuf(url, {
            interactive: true,
            minNativeZoom: 11,
            maxNativeZoom: 15,
            minZoom: 9,
            maxZoom: 18,
            vectorTileLayerStyles: {
                [layerName]: function(properties){
                    return getStyles(id, properties, color, option)
                },
                ["meta"]: function(properties){
                    return {
                        fill: false,
                        color: "transparent",
                        fillColor: "transparent",
                        fillOpacity: 0
                    }
                }
            },
        })

        vectorGrid.on('click', function(e) {
            
            // 対象外シェイプがクリックされた場合は無視する
            if ( ! checkTarget(id, e.layer.properties)) {
                return;
            }
            
            setLat(e.latlng.lat)
            setLng(e.latlng.lng)
            setPolygonProperties(e.layer.properties)
            setShowPopup(true)
       });
        
        vectorGrid.addTo(map)

        return () => vectorGrid.remove()
    }, [state.opacity])
    
    return (showPopup ? <Popup98
      latitude={lat}
      longitude={lng}
      feature={polygonProperties}
      option={option}
      closePopup={() => {
        setShowPopup(false)
      }}
    /> : null)
}

export default VectorGrid98
